import { render, staticRenderFns } from "./SettingsApp.vue?vue&type=template&id=6a0c544c&scoped=true"
import script from "./SettingsApp.vue?vue&type=script&lang=js"
export * from "./SettingsApp.vue?vue&type=script&lang=js"
import style0 from "./SettingsApp.vue?vue&type=style&index=0&id=6a0c544c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c544c",
  null
  
)

export default component.exports